import React from 'react';
import PropTypes from 'prop-types';
import {
    Input,
    Fields,
    icons,
    HorizontalFlex,
    FieldLabel,
    ButtonWithIconSecondary,
    SingleSelect,
} from 'smartsuite-ui';
import { useLabelContext } from '../hooks/labelContext';
import { getMeasurePredicateOptions } from './filtersModalUtils';

export default function MeasureFilterInput({
    deleteWhereClause,
    handleChange,
    index,
    measureOptions,
    whereClause,
}) {
    const { dashboardLabels, predicateLabels } = useLabelContext();
    const predicateOptions = getMeasurePredicateOptions(predicateLabels);

    if (!whereClause.propertyName) {
        return (
            <Fields cssClassModifiers={['no-background', 'no-pad-top-bottom']}>
                <SingleSelect
                    onChange={handleChange(index, 'propertyName')}
                    options={measureOptions}
                    placeholder={dashboardLabels.addMeasure}
                    textField="textField"
                    valueField="valueField"
                    value={undefined}
                />
            </Fields>
        );
    }

    /* eslint-disable complexity,no-restricted-globals */
    return (
        <Fields
            cssClassModifiers={[
                'no-background',
                'no-pad-top-bottom',
                'no-wrap',
            ]}
        >
            <SingleSelect
                label={
                    <HorizontalFlex>
                        <FieldLabel>
                            {whereClause?.propertyName?.textField}
                        </FieldLabel>
                        <ButtonWithIconSecondary
                            iconClass={icons.x}
                            onClick={deleteWhereClause(index)}
                        />
                    </HorizontalFlex>
                }
                isClearable={false}
                onChange={handleChange(index, 'predicate')}
                options={predicateOptions}
                isValid={!!whereClause.predicate}
                textField="textField"
                valueField="valueField"
                value={whereClause.predicate}
            />
            <Input
                isValid={
                    whereClause.values[0] !== '' &&
                    !isNaN(whereClause.values[0])
                }
                onChange={handleChange(index, 'values')}
                type="Number"
                value={whereClause.values[0]}
            />
        </Fields>
    );
    /* eslint-enable complexity,no-restricted-globals */
}

MeasureFilterInput.propTypes = {
    deleteWhereClause: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    measureOptions: PropTypes.instanceOf(Array).isRequired,
    whereClause: PropTypes.instanceOf(Object).isRequired,
};
